import { css } from 'lit';
import componentStyles from '../styles/component.styles';
import blockStyles from '../styles/block.styles';
export default css `
${componentStyles}
${blockStyles}
/**
--------------------------------------------------
* General
--------------------------------------------------
*/

:host{
  flex-grow: 1;
}

.video-list-page {
  /* background: var(--p-bg-light); */
  padding: var(--p-gap) 0 var(--p-section-padding);
}

.container {
  width: min(var(--p-container-width), 100% - 2 * var(--p-gap));
  margin-inline: auto;
  display: grid;
  gap: var(--p-gap);
  grid-template-columns: 250px 1fr;
}
@media (max-width: 768px) {
  .container {
    grid-template-columns:  1fr;
  }

  .video-listing li {
    margin-bottom: .5em;
  }
}

header {
  display: flex;
  flex-direction: row;
  align-items: baseline;
  margin-bottom: 1rem;
  justify-content: space-between;
  outline: none; //we will focus on this when a folder is selected but dont want the outline to be visible
}

@media (max-width: 768px) {
  header {
    flex-direction: column;
  }

}

h1 {
  display: inline-block;
  font-size: var(--p-h2-font-size);
  margin: 0;
  margin-right: 1rem;
  line-height: var(--p-h2-line-height);
}

.items {
  display: inline-block;
  font-size: var(--p-font-size-small);
  opacity: var(--p-text-meta-opacity);
}

@media (max-width: 768px) {
  .file-tree {
    display: none;
  }
}

.video-listing {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(var(--p-video-item-width), 1fr));
  gap: var(--p-video-grid-gap);
  list-style: none;
  padding: 0;
  margin: 0;
}

:host([dark]) {
  --p-section-bg: var(--p-bg-dark);
  --p-text-color: var(--p-text-color-light);
  --p-expand-bg-hover: var(--p-text-color-light-contrast-100);
  --p-expand-selected-bg-hover: var(--p-text-color-light-contrast-100);
}

`;
